/** Window permission letters. */
export const RBAC_PERMISSION = { READ: 'R', WRITE: 'W', DELETE: 'D' } as const;

/** Report permission letters (D = download, not delete). */
export const RBAC_REPORT_PERMISSION = { VIEW: 'R', DOWNLOAD: 'D' } as const;

/** Window codes, by module. */
export const RBAC_WINDOW = {
  ACCOUNT: { ACCOUNT: 'ACT', RELATION: 'ACTR' },
  STUDY: { STUDY: 'STD' },
  USERS: { USER: 'USR', PERMISSION: 'UPM' },
  MASTER: { THERAPEUTIC: 'THR', INDICATION: 'INDCT', PHASE: 'PHS', ROLE: 'ROLE' },
  AUDIT_LOG: { AUDIT_LOG: 'ADT' },
  RBAC: { ENTITY: 'RBAC_ENT', MODULE: 'RBAC_MOD', WINDOW: 'RBAC_WIN', ACTION: 'RBAC_ACT', REPORT: 'RBAC_RPT' }
} as const;

/** Action codes (buttons / icons other than add, edit, delete), by module. */
export const RBAC_ACTION = {
  STUDY: { SITE_ADD: 'STD_ST_ADD', SITE_DELETE: 'STD_ST_DLT' },
  USERS: { LOCK_UNLOCK: 'USR_LOCK_UNLOCK', RESET_PASSWORD: 'USR_RST_PWD', ENABLE_DISABLE: 'USR_ENABLE_DISABLE' }
} as const;

/** Report codes, by module. */
export const RBAC_REPORT = {
  USERS: { EXPORT: 'USR_EXP_REPORT' }
} as const;

/** For templates: protected readonly RBAC = RBAC_CODES; then *rbacAction="RBAC.ACTION.USERS.LOCK_UNLOCK". */
export const RBAC_CODES = {
  PERMISSION: RBAC_PERMISSION,
  REPORT_PERMISSION: RBAC_REPORT_PERMISSION,
  WINDOW: RBAC_WINDOW,
  ACTION: RBAC_ACTION,
  REPORT: RBAC_REPORT
} as const;

/** All string values of a (nested) constants object. */
type ValuesOf<T> = T extends string ? T : { [K in keyof T]: ValuesOf<T[K]> }[keyof T];

export type PermissionCode = ValuesOf<typeof RBAC_PERMISSION>;
export type ReportPermissionCode = ValuesOf<typeof RBAC_REPORT_PERMISSION>;
export type WindowCode = ValuesOf<typeof RBAC_WINDOW>;
export type ActionCode = ValuesOf<typeof RBAC_ACTION>;
export type ReportCode = ValuesOf<typeof RBAC_REPORT>;
